export default function Container({
  children,
  className = '',
  ...props
}) {
  return (
    <div className={`mx-auto max-w-[72.6rem] ${className}`} {...props}>
      {children}
    </div>
  );
}